import { Col, Table, TableActionBarRow } from "melco-ui";
import { useTranslation } from "react-i18next";

import { useState } from "react";
import { IdentityMelcoModelsProductListItem } from "melco-shared-logic";
import { useGetAllProductsList } from "../../hooks/product/useGetAllProductsList";
import { EditProductDrawer } from "./drawer/EditProductDrawer";
import { Search } from "../search/Search";
import { TableCellLink } from "../table/TableCellLink";
import { useRolesContext } from "../../hooks/roles/useRolesContext";

export const ProductsList: React.FC = () => {
  const {
    isLoading,
    isFetching,
    data,
    isPreviousData,
    errorComponent,
    onTableConfigChange,
    pagination,
    searchQueryChange,
    refetch,
  } = useGetAllProductsList();
  // const runTable = useLicences();
  const { t } = useTranslation();
  // const {allProducts} = useProducts();
  const { roles } = useRolesContext();
  //  console.log(allProducts);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  // http://test-admin.melcocloud.com/Report/ProductionBilling

  console.log(data);

  const columns = [
    {
      title: t("products_list.table.columns.name"),
      key: "name",
      //dataIndex: "name",
      sorter: true,
      width: 30,
      render: (rowObj: any) => {
        return (
          <div>
            {roles.SYSTEM_PRODUCTS_EDIT ? (
              <TableCellLink
                onClick={() => {
                  handleEditClick(rowObj);
                }}
                to={""}
              >
                {rowObj.name}
              </TableCellLink>
            ) : (
              rowObj.name
            )}
          </div>
        );
      },
    },
    {
      title: t("products_list.table.columns.code"),
      key: "code",
      dataIndex: "code",
      sorter: true,
      width: 30,
    },

    {
      title: t("products_list.table.columns.desc"),
      key: "description",
      dataIndex: "description",
      sorter: true,
      width: 60,
    },
    {
      title: t("products_list.table.columns.url"),
      key: "app_startup_endpoint",
      //dataIndex: "app_startup_endpoint",
      sorter: true,
      width: 50,
      render: (rowObj: any) => (
        <a
          href={rowObj.app_startup_endpoint}
          target="_blank"
          style={{ color: "#a91700", textDecoration: "underline" }}
        >
          {rowObj.app_startup_endpoint}
        </a>
      ),
    },

    //   {
    //     title: "Edit",
    //     key: "edit_action",
    //     width: 15,
    //     render: (rowObj: any) => (
    //         <div >
    //             <Button
    //                 icon={<EditIcon />}
    //                 type="primary"
    //                 // loading={isCurrentlyReverting}
    //                 onClick={() => {
    //                     handleEditClick(rowObj)
    //                 }}
    //             >
    //             </Button>

    //         </div>
    //     ),
    // },
  ];

  const [isEditDrawerOpen, setEditDrawerOpen] = useState(false);
  const [editProductDetails, setEditProductDetails] =
    useState<IdentityMelcoModelsProductListItem>();

  const setEditDrawerAction = (action: boolean) => {
    setEditDrawerOpen(action);
    refetch();
  };

  const handleEditClick = (item: IdentityMelcoModelsProductListItem) => {
    setEditProductDetails(item);
    setEditDrawerAction(true);
  };

  return (
    <>
      <TableActionBarRow>
        <Col>
          <Search
            onSearchInputChange={(query: string) => searchQueryChange(query)}
          />
        </Col>
      </TableActionBarRow>
      <Table
        showSorterTooltip={false}
        sticky
        loading={isPreviousData ? isFetching : isLoading}
        dataSource={data}
        columns={columns}
        onChange={onTableConfigChange}
        pagination={pagination}
        rowKey="code"
        // rowSelection={rowSelection}
        // onRow={onRow}
        noDataMessage={t("products_list.no_products_message")}
        errorComponent={errorComponent}
      //scroll={{ x: 1700 }}
      />

      {roles.SYSTEM_PRODUCTS_EDIT && isEditDrawerOpen && editProductDetails && (
        <EditProductDrawer
          isDrawerOpen={isEditDrawerOpen}
          setDrawerOpen={setEditDrawerAction}
          productDetails={editProductDetails}
        />
      )}
    </>
  );
};
